export type RouteGroup =
  | "home"
  | "wizard"
  | "account"
  | "billing"
  | "support"
  | "fineTuning"
  | "visualMachine"
  | "layoutDesign"
  | "dashboard"
  | "analytics"
  | "setup"
  | "terms"
  | "notfound";

export interface RouteMeta {
  name: string;
  path: string;
  group: RouteGroup;
}

export const ROUTES: readonly RouteMeta[] = [
  { name: "login", path: "/", group: "home" },
  { name: "signup", path: "/signup", group: "home" },
  { name: "activation", path: "/activation", group: "home" },
  { name: "crm-login", path: "/crm-login", group: "home" },
  { name: "activation-mail", path: "/activation-mail", group: "home" },
  { name: "forgot-password", path: "/forgot-password", group: "home" },
  { name: "reset-password", path: "/recovery", group: "home" },
  { name: "wizard-start", path: "/wizard", group: "wizard" },
  { name: "wizard-cms", path: "/wizard/cms", group: "wizard" },
  { name: "wizard-shop", path: "/wizard/shop", group: "wizard" },
  { name: "wizard-settings", path: "/wizard/settings", group: "wizard" },
  { name: "account", path: "/account", group: "account" },
  { name: "billing", path: "/billing", group: "billing" },
  { name: "billing-overview", path: "/billing/overview", group: "billing" },
  { name: "billing-plans", path: "/billing/plans", group: "billing" },
  { name: "billing-information", path: "/billing/information", group: "billing" },
  { name: "support", path: "/support", group: "support" },
  { name: "fineTuning", path: "/fineTuning", group: "fineTuning" },
  { name: "visualMachine", path: "/visualMachine", group: "visualMachine" },
  { name: "visualMachine-campaigns", path: "/visualMachine/campaigns", group: "visualMachine" },
  { name: "visualMachine-banners", path: "/visualMachine/banners", group: "visualMachine" },
  { name: "visualMachine-recommendations", path: "/visualMachine/recommendations", group: "visualMachine" },
  { name: "layoutDesign", path: "/layoutDesign", group: "layoutDesign" },
  { name: "layoutDesign-general", path: "/layoutDesign/general", group: "layoutDesign" },
  { name: "layoutDesign-desktop", path: "/layoutDesign/desktop", group: "layoutDesign" },
  { name: "layoutDesign-mobile", path: "/layoutDesign/mobile", group: "layoutDesign" },
  { name: "layoutDesign-card", path: "/layoutDesign/card", group: "layoutDesign" },
  { name: "layoutDesign-builder", path: "/layoutDesign/builder", group: "layoutDesign" },
  { name: "layoutDesign-customStyle", path: "/layoutDesign/customStyle", group: "layoutDesign" },
  { name: "dashboard", path: "/dashboard", group: "dashboard" },
  { name: "analytics", path: "/analytics", group: "analytics" },
  { name: "analytics-overview", path: "/analytics/overview", group: "analytics" },
  { name: "analytics-filters", path: "/analytics/filters", group: "analytics" },
  { name: "analytics-queries", path: "/analytics/queries", group: "analytics" },
  { name: "setup", path: "/setup", group: "setup" },
  { name: "search-configuration", path: "/setup/search", group: "setup" },
  { name: "advanced-settings", path: "/setup/settings", group: "setup" },
  { name: "terms", path: "/terms", group: "terms" },
  { name: "notfound", path: "/notfound", group: "notfound" },
];

const NOT_FOUND = ROUTES.find((route) => route.name === "notfound") as RouteMeta;

export function routeByName(name: string): RouteMeta | undefined {
  return ROUTES.find((route) => route.name === name);
}

/** Stessa regola del legacy: uguaglianza esatta del pathname, provando prima i percorsi piu' lunghi. */
export function resolveRoute(pathname: string): RouteMeta {
  const byLength = [...ROUTES].sort((a, b) => b.path.length - a.path.length);
  return byLength.find((route) => route.path === pathname) ?? NOT_FOUND;
}
